import axios from 'axios'
// import { convrrtV1 } from '../../lib/firebase'

// const database = convrrtV1.database()

const client = axios.create({
  baseURL: '/'
})

export default {
  namespaced: true,

  state: {
    site: {}
  },

  actions: {
    async load ({ state }) {
      const { data } = await client.get('/settings.json')
      return state.site = data
    }
  }
}
